import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PrestamosService } from '../../../services/prestamos.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import { RutasService } from '../../../services/rutas.service';
@Component({
  selector: 'app-prestamos',
  templateUrl: './prestamos.component.html',
  styleUrls: ['./prestamos.component.css']
})
export class PrestamosComponent implements OnInit {
  form: FormGroup;
  rutas = [];
  loading = false;
  loaded = false;
  otraFormaPago = false;
  config_zona = 0;

  @Input('ID_RUTA') ID_RUTA: number;
  constructor(
    private prestamoService: PrestamosService,
    private modals: AlertasModales,
    private rutasService: RutasService,
    private empleadoService: EmpleadosServicio) {
  }

  ngOnInit() {
    this.initForm();
  }

  private initForm(): void {
    this.form = new FormGroup({
      ID_EMPLEADO: new FormControl(this.empleadoService.datosEmpleado.ID_EMPLEADO, Validators.required),
      interes: new FormControl('', Validators.required),
      mora: new FormControl('' , Validators.required),
      plazo: new FormControl('', [Validators.required, Validators.minLength(1)]),
      tipoPlazo: new FormControl('', Validators.required),
      ciclo: new FormControl('', Validators.required),
      ciclodiaSemanaInicia: new FormControl('', Validators.required),
      tipoInteres: new FormControl('',Validators.required),
      semana: new FormControl('', Validators.required),
      plazoEnDias: new FormControl('', Validators.required),
      formaPago: new FormControl('', Validators.required),
      diasExcluir: new FormControl('', Validators.required),
      diasGracia: new FormControl('', [Validators.required, Validators.minLength(0)]),
      recaudar_prestamos_nuevos: new FormGroup({
        tipo_gasto_cierre: new FormControl('1'),
        monto_gasto_cierre: new FormControl(0),
        monto_incremento: new FormControl(0),
      }),
      recaudar_renovaciones: new FormGroup({
        tipo_gasto_cierre: new FormControl('1'),
        monto_gasto_cierre: new FormControl(0),
        monto_incremento: new FormControl(0),
      }),
      minimo_cuota_renovacion: new FormControl('1', [Validators.required, Validators.min(1)]),
      minimo_cuotas_atraso: new FormControl('0', [Validators.required, Validators.min(0)]),
      porciento_renovar: new FormControl('0', Validators.required),
    });

    this.initConfiguracion();
  }

  private initConfiguracion() {

      this.prestamoService.obtenerConfiguracionPrestamo(this.ID_RUTA)
      .subscribe((res: any) => {
        if (res.config_zona) {
          this.config_zona = 1;
        }
        this.form.get('interes').setValue(res.tazaInteres);
        this.form.get('tipoInteres').setValue(res.tipoInteres);
        this.form.get('mora').setValue(res.moraPorciento);
        this.form.get('plazo').setValue(res.plazo);
        this.form.get('ciclo').setValue(res.ciclo);
        this.form.get('ciclodiaSemanaInicia').setValue(res.dia_inicia_semana);
        this.form.get('semana').setValue(res.semana);
        this.form.get('tipoPlazo').setValue(res.tipoPlazo);
        this.form.get('plazoEnDias').setValue(res.plazoEnDias);
        this.form.get('formaPago').setValue(String(res.formaPago));
        this.form.get('diasExcluir').setValue(String(res.diasExcluir));
        this.form.get('diasGracia').setValue(res.dias_gracia);
        this.form.get('minimo_cuota_renovacion').setValue(res.minimo_cuota_renovacion);
        this.form.get('minimo_cuotas_atraso').setValue(res.minimo_cuotas_atraso);
        this.form.get('porciento_renovar').setValue(res.porciento_renovar);
        this.form
        .get('recaudar_prestamos_nuevos')
        .get('tipo_gasto_cierre').setValue(String(res.pn_tipo_gasto_cierre));
        this.form
        .get('recaudar_prestamos_nuevos')
        .get('monto_gasto_cierre').setValue(res.pn_monto_gasto_cierre);
        this.form
        .get('recaudar_prestamos_nuevos')
        .get('monto_incremento').setValue(res.pn_monto_incremento);
        this.form
        .get('recaudar_renovaciones')
        .get('tipo_gasto_cierre').setValue(String(res.r_tipo_gasto_cierre));
        this.form
        .get('recaudar_renovaciones')
        .get('monto_gasto_cierre').setValue(res.r_monto_gasto_cierre);
        this.form
        .get('recaudar_renovaciones')
        .get('monto_incremento').setValue(res.r_monto_incremento);
        setTimeout(() => this.loaded = true, 1);
      });
  }

  formChange() {
    const plazoEnDias = parseFloat(this.form.get('plazo').value) * parseFloat(this.form.get('tipoPlazo').value);
    this.form.get('plazoEnDias').setValue(plazoEnDias);
  }

  actualizarConfiguracion() {
    if (this.form.valid) {
      this.loading = true;

      if (this.form.get('ciclo').value <= 4 && this.form.get('semana').value <= 13  ) {

      this.prestamoService.configurarPrestamo(this.form.value, this.ID_RUTA)
      .subscribe(() => {
        setTimeout(() => this.loading = false, 1);
        this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
      }, err => {
        setTimeout(() => this.loading = false, 1);
        if (err) {
          if ((err.hasOwnProperty('status') && err.status === 0) ||
          (err.hasOwnProperty('name') && err.name === 'TimeoutError')) {
            this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
              'orange',
              'modern',
              false,
              'fa fa-wifi');
          } else {
            this.modals.validacionesModalJquery('Ups, ha ocurrido un error inesperado', err, 'red', 'modern');
          }

        }
      });
    } else {
      this.modals.validacionesModalJquery('Ciclo debe ser menor a igual a 4 y semana no puede ser mayor a 13', '',
      'orange',
      'modern',
      false,
      'fa fa-exclamation-triangle');
      this.loading = false;

    }

    }
  }

  resetRutaConfig() {
    if (this.config_zona) {
      // tslint:disable-next-line:max-line-length
      this.modals.confirmModalJquery('Restablecer Configuración', 'Estas Seguro que deseas restablecer a la configuración por defecto?', 'orange').then(resp => {
        if (resp && resp === 'SI') {

          this.rutasService.restablecerConfiguracionRuta(this.ID_RUTA).subscribe((res) => {
            this.initConfiguracion();
          });
        }
      });
    }
  }

  anularMora() {
    this.prestamoService.anularMoraTodos().subscribe(() => {
      this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
    }, err => {
      this.modals.validacionesModalJquery('Ups, ha ocurrido un error inesperado', err, 'red', 'modern');
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/configuraciones/prestamos/prestamos.component.ts